import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { SiteStore } from '@core/site/site.store';
import { ThemeService } from '@core/theme/theme.service';
import { THEME_LABELS, type ThemeName } from '@abook-ui/theme/theme.model';

@Component({
  selector: 'app-theme-switcher',
  imports: [MatButtonModule, MatIconModule, MatMenuModule],
  templateUrl: './theme-switcher.html',
  styleUrl: './theme-switcher.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThemeSwitcherComponent {
  protected siteStore = inject(SiteStore);
  protected themeService = inject(ThemeService);

  readonly themeLabels = THEME_LABELS;

  selectTheme(name: ThemeName): void {
    if (name !== this.siteStore.theme()) {
      this.siteStore.switchTheme(name);
    }
  }
}
